module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/account-closure/account-closure.component.css
// module id = ./src/app/accountmaster/account-closure/account-closure.component.css
// module chunks = main